import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-comercial-mia-gestor',
  templateUrl: './comercial-mia-gestor.component.html',
  styleUrls: ['./comercial-mia-gestor.component.scss'],
})
export class ComercialMiaGestorComponent implements OnInit, OnDestroy {
  atendimentos: any[] = [];
  selecionado: any = null;
  carregando = false;
  abrindo = false;
  salvando = false;
  erro = '';
  filtro = '';
  private timer: any;
  private atualizando = false;
  private detalheVersao = 0;
  private destruido = false;
  constructor(private http: HttpClient) {}
  ngOnInit() { this.atualize(); this.timer = setInterval(() => this.atualize(false), 15000); }
  ngOnDestroy() { this.destruido = true; clearInterval(this.timer); this.detalheVersao++; }
  get filtrados() {
    const termo = this.filtro.trim().toLocaleLowerCase();
    return this.atendimentos.filter(a => `${a.nome} ${a.waId} ${a.encaminhamento?.motivo || ''}`.toLocaleLowerCase().includes(termo));
  }
  get fatos() {
    return Object.entries(this.selecionado?.ficha?.fatos || {}).map(([campo, valor]: [string, any]) => ({campo: campo.replace(/_/g, ' '), ...valor}));
  }
  get estado() {
    if (this.selecionado?.controle?.habilitada === false) return 'Atendimento automático desabilitado';
    if (this.selecionado?.controle?.bloqueada) return 'Mia desativada para este contato';
    if (this.selecionado?.controle?.pausada) return 'Com a equipe';
    return 'Mia atendendo';
  }
  atualize(indicar = true) {
    if (this.atualizando || this.destruido) return;
    this.atualizando = true;
    this.carregando = indicar;
    this.http.get<any[]>('/gestor-ia/comercial').subscribe({
      next: itens => {
        this.atualizando = false;
        if (this.destruido) return;
        this.erro = '';
        this.atendimentos = itens;
        this.carregando = false;
        if (this.selecionado && !this.salvando) this.abra(this.selecionado.atendimentoId, false);
      },
      error: () => { this.atualizando = false; this.carregando = false; this.erro = 'Não foi possível atualizar os atendimentos. Tente novamente.'; }
    });
  }
  abra(id: number, indicar = true) {
    const versao = ++this.detalheVersao;
    this.abrindo = indicar;
    if (indicar) { this.selecionado = null; this.erro = ''; }
    this.http.get<any>(`/gestor-ia/comercial/${id}`).subscribe({
      next: item => { if (versao !== this.detalheVersao) return; this.selecionado = item; this.abrindo = false; },
      error: () => { if (versao !== this.detalheVersao) return; this.abrindo = false; this.erro = 'Não foi possível abrir esta conversa.'; }
    });
  }
  controle(acao: 'humano' | 'devolver' | 'bloquear') {
    if (!this.selecionado || this.salvando) return;
    const id = this.selecionado.atendimentoId;
    this.salvando = true; this.erro = '';
    this.http.post(`/gestor-ia/comercial/${id}/controle`, {acao}).subscribe({
      next: () => { this.salvando = false; if (this.selecionado?.atendimentoId === id) this.abra(id, false); },
      error: () => { this.salvando = false; this.erro = 'A mudança não foi confirmada. Atualize a conversa antes de tentar novamente.'; }
    });
  }
}
